import { render, staticRenderFns } from "./MortalityListAdd.vue?vue&type=template&id=774bece4&scoped=true&"
import script from "./MortalityListAdd.vue?vue&type=script&lang=js&"
export * from "./MortalityListAdd.vue?vue&type=script&lang=js&"
import style0 from "./MortalityListAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MortalityListAdd.vue?vue&type=style&index=1&id=774bece4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774bece4",
  null
  
)

export default component.exports